// extracted by mini-css-extract-plugin
export default {"-large":"poster-popup-menu-module__-large--y5SG_","canvasPopupMenu":"poster-popup-menu-module__canvasPopupMenu--adoOw"};